export default () => {
  return (
    <svg
      id="text"
      data-name="text"
      viewBox="0 0 30 30"
      width="36"
      height="36"
    >
      <path
        id="Modules"
        d="M27.5,8.4H26.1a4.72,4.72,0,0,0-.7-1.7,11.78,11.78,0,0,0-1.1-1.9A11.22,11.22,0,0,0,23,3.2a2.54,2.54,0,0,0-1.4-.8A7.12,7.12,0,0,0,20,2.3H17v23a2.38,2.38,0,0,0,.3,1.2,1.79,1.79,0,0,0,1,.9c.2.1.8.2,1.5.4a8.2,8.2,0,0,0,1.8.3v1.4H8V28a14.92,14.92,0,0,0,1.7-.2,9.11,9.11,0,0,0,1.6-.3,2,2,0,0,0,1-.8,2.5,2.5,0,0,0,.3-1.3V2.2H9.8c-.6,0-1.2.1-1.8.1a2.92,2.92,0,0,0-1.4.8A10.1,10.1,0,0,0,5.3,4.7,18.56,18.56,0,0,0,4.2,6.6a8.8,8.8,0,0,0-.6,1.7H2.2V.5H27.3V8.4Z"
      ></path>
    </svg>
  );
};
